import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LoadingOverlay from '../../components/others/LoadingOverlay';
import { LayoutEpayco } from './layout/LayoutEpayco';
import axios from 'axios';
import { useAudit } from '../../hooks/useAudit';

const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;

const EpaycoScreen = () => {
    const navigate = useNavigate();
    const { getAuditData } = useAudit();
    const { subscriptionPlan } = useParams();

    const [status, setStatus] = useState('loading');
    const [token, setToken] = useState(null);

    useEffect(() => {
        const validateRegistration = async () => {
            try {
                const auditData = await getAuditData();
                const lastDash = subscriptionPlan.lastIndexOf("-");
                // setStatus('success');
                //OTAwMTE0MDk4OnNlYnlIcFdZcWlZM0RIVllsODhjWmFYaVNNSlNCZ0VrOXFDNU9SUUJlNUFyZk01NU95MTRWZUY2eGsyczcyOTA
                try {
                    let config = {
                        method: 'POST',
                        url: baseUrlFlow,
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Basic OTAwMTE0MDk4OnNlYnlIcFdZcWlZM0RIVllsODhjWmFYaVNNSlNCZ0VrOXFDNU9SUUJlNUFyZk01NU95MTRWZUY2eGsyczcyOTA=`
                        },
                        data: JSON.stringify({
                            id_flow: "900114098-API-GENERATE-TOKEN-REGISTRATION",
                            subscription_plan: subscriptionPlan,
                            // plan_uuid: subscriptionPlan,
                            plan_uuid: subscriptionPlan.substring(0, lastDash),
                            erp: subscriptionPlan.substring(lastDash + 1),
                            ip: auditData.ip
                        })
                    };
                    const response = await axios.request(config);
                    console.log('validatePageRegistration', response);
                    if (response.status === 200) {
                        setToken(response.data.token);
                        setStatus('success');
                    } else {
                        navigate('/Loguin');
                        setStatus('error');
                    }
                } catch (error) {
                    console.log('error', error);
                }
            } catch (error) {
                console.error("Error validando token:", error);
                setStatus('error');
            }
        };

        if (subscriptionPlan) {
            validateRegistration();
        }
    }, [subscriptionPlan, navigate]);

    if (status === 'loading') {
        return <LoadingOverlay
            isOpen={true}
            text={'Cargando...'}
        />
    }

    if (status === 'error' || !token) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography color="error" variant="h6">
                    El enlace de registro no es válido o ha expirado.
                </Typography>
            </Box>
        );
    }

    return <LayoutEpayco
        token={token}
        subscriptionPlan={subscriptionPlan}
    />;
};

export default EpaycoScreen;